import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbAccordionModule, NgbActiveModal, NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { CheckBoxModule } from "@progress/kendo-angular-inputs";
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DisableifDirective } from '../admin/location/directives/disableif.directive';
import { LobbyCheckInModule } from '../lobby/lobby-check-in/lobby-check-in.module';
import { LobbyStatusBarComponent } from '../lobby/lobby-status-bar/lobby-status-bar.component';
import { LobbyStatusBarModule } from '../lobby/lobby-status-bar/lobby-status-bar.module';
import { LobbyWrapUpModule } from '../lobby/lobby-wrap-up/lobby-wrap-up.module';
import { TransferImpersonateAssistsComponent } from '../lobby/transfer-impersonate-assists/transfer-impersonate-assists.component';
import { AlertsComponent } from './alerts/alerts.component';
import { InputFilterDirective } from './directives/input-filter.directive';
import { NoLeadingTrailingWhiteSpaceDirective } from './directives/no-leading-trailing-whitespace.directive';
import { NotfoundComponent } from './errorpages/notfound/notfound.component';
import { AppBreadcrumbComponent } from './layout/app-layout/app-breadcrumb/app-breadcrumb.component';
import { AppHeaderComponent } from './layout/app-layout/app-header/app-header.component';
import { AppSigninPanelComponent } from './layout/app-layout/app-header/app-signin-panel/app-singin-panel.component';
import { SignoutModalComponent } from './layout/app-layout/app-header/signout/signout-modal/signout-modal.component';
import { SignoutComponent } from './layout/app-layout/app-header/signout/signout.component';
import { AppHeaderEffects } from './layout/app-layout/app-header/state/app-header.effects';
import { appHeaderReducer } from './layout/app-layout/app-header/state/app-header.reducer';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { AppLeftNavbarComponent } from './layout/app-layout/app-left-navbar/app-left-navbar.component';
import { AppTenantChangeComponent } from './layout/app-layout/app-tenantchange-popup/app-tenantchange-popup.component';
import { AppTimerButtonComponent } from './layout/app-layout/app-timer-button/app-timer-button.component';
import { AppTimerModule } from './layout/app-layout/app-timer/app-timer.module';
import { LeftWithoutAssistanceComponent } from './modalpopup/left-without-assistance/left-without-assistance.component';
import { LicensingPermissionPopupComponent } from './modalpopup/licensing-permission-popup/licensing-permission-popup.component';
import { LobbyDetailEditComponent } from './modalpopup/lobby-detail-edit/lobby-detail-edit.component';
import { LobbyEditComponent } from './modalpopup/lobby-edit/lobby-edit.component';
import { LobbyEntriesDeleteComponent } from './modalpopup/lobby-entries-delete/lobby-entries-delete.component';
import { LocationMultiSelectorTreeViewComponent } from './modalpopup/location-multi-selector/location-multi-selector-tree-view/location-multi-selector-tree-view.component';
import { LocationMultiSelectorComponent } from './modalpopup/location-multi-selector/location-multi-selector.component';
import { LocationSelectorModule } from './modalpopup/location-selector/location-selector-module';
import { LocationsDropDownCheckBoxTreeViewComponent } from './modalpopup/locations-drop-down-treeview/locations-drop-down-check-box-tree-view-component';
import { ModalPopupImplComponent } from './modalpopup/modal-popup-impl/modal-popup-impl.component';
import { ModalpopupComponent } from './modalpopup/modalpopup.component';
import { NotificationGroupPopupComponent } from './modalpopup/notification-Group/notification-group-popup/notification-group-popup.component';
import { SignInModalPopupComponent } from './modalpopup/sign-in-modal-popup/sign-in-modal-popup.component';
import { TransferAssistInfoPopupComponent } from './modalpopup/transfer-assist-info-popup/transfer-assist-info-popup.component';
import { UserMultiSelectorTreeViewComponent } from './modalpopup/user-multi-selector/user-multi-selector-tree-view/user-multi-selector-tree-view.component';
import { UserMultiSelectorComponent } from './modalpopup/user-multi-selector/user-multi-selector.component';
import { UserSelectorTreeViewComponent } from './modalpopup/user-selector/user-selector-tree-view/user-selector-tree-view.component';
import { UserSelectorComponent } from './modalpopup/user-selector/user-selector.component';
import { UsersDropDownCheckBoxTreeViewComponent } from './modalpopup/users-drop-down-checkbox-treeview/users-drop-down-check-box-tree-view-component';
import { UsersDropDownSelectTreeViewComponent } from './modalpopup/users-drop-down-treeview/users-drop-down-select-tree-view-component';
import { ImpersonationTransferOptionFilterPipe } from './pipes/impersonation-transfer-option.pipe';
import { ImpersonationTransferSelectDisablePipe } from './pipes/impersonation-transfer-select-disable.pipe';
import { SplitCamelCasePipe } from './pipes/splitcamelcase.pipe';
import { StaffStatusPipe } from './pipes/statusmessage.pipe';
import { TimeToAnotherTimeZoneConversion } from './pipes/timeToAnotherTimeZoneConversion.pipe';
import { UtcOffsetConversion } from './pipes/utcoffsetconversion.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { LabelModule } from "@progress/kendo-angular-label";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { AppointmentStatusPipe } from './pipes/appointmentstatusmessage.pipe';
import { HolidayStatusPipe } from './pipes/holidaystatusmessage.pipe';
import { IframeService } from './services/iframe.service';

@NgModule({
  declarations: [
    NotfoundComponent,
    AppHeaderComponent,
    AppLayoutComponent,
    AppLeftNavbarComponent,
    ModalpopupComponent,
    SignoutModalComponent,
    SignoutComponent,
    AppBreadcrumbComponent,
    AlertsComponent,
    InputFilterDirective,
    NoLeadingTrailingWhiteSpaceDirective,
    UtcOffsetConversion,
    TimeToAnotherTimeZoneConversion,
    StaffStatusPipe,
    AlertsComponent,
    ModalPopupImplComponent,
    AppTenantChangeComponent,
    AppSigninPanelComponent,
    LeftWithoutAssistanceComponent,
    LocationsDropDownCheckBoxTreeViewComponent,
    UsersDropDownSelectTreeViewComponent,
    UsersDropDownCheckBoxTreeViewComponent,
    LobbyDetailEditComponent,
    LobbyEditComponent,
    NotificationGroupPopupComponent,
    LicensingPermissionPopupComponent,
    UserSelectorComponent,
    UserSelectorTreeViewComponent,
    UserMultiSelectorComponent,
    UserMultiSelectorTreeViewComponent,
    SplitCamelCasePipe,
    LocationMultiSelectorComponent,
    LocationMultiSelectorTreeViewComponent,
    SignInModalPopupComponent,
    LobbyEntriesDeleteComponent,
    AppTimerButtonComponent,
    DisableifDirective,
    TransferImpersonateAssistsComponent,
    TransferAssistInfoPopupComponent,
    ImpersonationTransferOptionFilterPipe,
    ImpersonationTransferSelectDisablePipe,
    AppointmentStatusPipe,
    HolidayStatusPipe
  ],
  imports: [
    DropDownsModule,
    CheckBoxModule,
    NgMultiSelectDropDownModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ButtonsModule,
    GridModule,
    DateInputsModule,
    ReactiveFormsModule,
    NgbModule,
    TooltipModule,
    DialogModule,
    LobbyCheckInModule,
    LobbyWrapUpModule,
    LobbyStatusBarModule,
    NgbDropdownModule,
    NgbAccordionModule,
    TreeViewModule,
    StoreModule.forFeature('appHeader', appHeaderReducer),
    EffectsModule.forFeature([AppHeaderEffects]),
    LocationSelectorModule,
    AppTimerModule,
    TranslateModule,
    InputsModule,
    LabelModule,
    LayoutModule,
  ],
  exports: [
    AppLayoutComponent,
    AppHeaderComponent,
    AppLeftNavbarComponent,
    NotfoundComponent,
    ModalpopupComponent,
    SignoutModalComponent,
    InputFilterDirective,
    NoLeadingTrailingWhiteSpaceDirective,
    UtcOffsetConversion,
    TimeToAnotherTimeZoneConversion,
    StaffStatusPipe,
    ModalPopupImplComponent,
    AlertsComponent,
    LeftWithoutAssistanceComponent,
    LocationsDropDownCheckBoxTreeViewComponent,
    UsersDropDownSelectTreeViewComponent,
    UsersDropDownCheckBoxTreeViewComponent,
    LobbyDetailEditComponent,
    LobbyEditComponent,
    LobbyEntriesDeleteComponent,
    LobbyStatusBarComponent,
    UserSelectorComponent,
    SplitCamelCasePipe,
    LocationMultiSelectorComponent,
    UserMultiSelectorComponent,
    AppTimerButtonComponent,
    LocationSelectorModule,
    DisableifDirective,
    TranslateModule,
    AppointmentStatusPipe,
    HolidayStatusPipe		  
  ],
  providers: [
    NgbActiveModal,
    IframeService
  ]
})
export class SharedModule { }
